import { createContext } from 'react';


const context = createContext({});

export default context;
export const CommentsConsumer = context.Consumer;